module.exports = __webpack_public_path__ + "img/start_template.9ed79e63.png";